module.exports = __webpack_public_path__ + "img/mind_template_item_3_1.21cba533.png";